export default {
  to: "/exemptions/listing",
  order: 3,
  icon: "mdi-folder-lock-open",
  title: "Exemptions",
  type: "admin",
  disabled: false,
};
